import React  from 'react';
import './MultiChoice.scss';
import OrangeCircle from './../../assets/svgs/orange-circle.svg';
import OrangeCircleEmpty from './../../assets/svgs/orange-circle-empty.svg';

type PropsRolls = {
  price: number;
  batchId: string;
  selected: boolean;
  length: number;
  width: number;
  onClick: () => void;
  rollType: 'F' | 'H' | string;
};

type PropsPallets = {
  price: number;
  palletQty: number;
  palletId: string;
  selected: boolean;
  onClick: () => void;
};

const Pallets = (props: PropsPallets) => {
  const {
    palletQty,
    price,
    palletId,
    onClick,
  } = props;
  return (
      <div className="multi-choice" onClick={onClick}>
        <div className="multi-choice__left">
          <div className="multi-choice__left__dot mr-2">
            <img src={props.selected ? OrangeCircle : OrangeCircleEmpty} alt="Orange Circle" />
          </div>
          <div className="multi-choice__left__price font-bold px-2">
            <p>Select Pallet</p>
            <p>£{price} per pack</p>
          </div>
        </div>
        <div className="multi-choice__right">
          <p>Pallet ID: {palletId}</p>
          <p>Pallet Qty: {palletQty}</p>
        </div>
      </div>
  );
};

const Rolls = (props: PropsRolls) => {
  const {
    price,
    batchId,
    rollType,
    length,
    width,
    onClick,
  } = props;
  return (
    <div className="multi-choice mb-3" onClick={onClick}>
      <div className="multi-choice__left">
        <div className="multi-choice__left__dot mr-2">
          <img src={props.selected ? OrangeCircle : OrangeCircleEmpty} alt="Orange Circle" />
        </div>
        <div className="multi-choice__left__price font-bold px-2">
          {rollType === 'F' && <p className="">Select Full Roll</p>}
          {rollType !== 'F' && <p className="">Select Roll</p>}
          <p>£{price} per SQM</p>
        </div>
      </div>
      <div className="multi-choice__right">
        <p>Batch ID: {batchId}</p>
        <p>L: {length}m, W: {width}m</p>
      </div>
    </div>
  );
};

export default { Rolls, Pallets };
